<template>
  <div v-if="description !== ''">
    <div class="product-description" v-html="description"></div>
  </div>
</template>

<style lang="scss" scoped>
</style>
<script>
export default {
  name: "WellsDescription",
  components: {},
  props: {
    excerpt: String,
    description: String
  },
  computed: {
  },
  methods: {}
};
</script>
